var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscussionAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-discussion",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-discussion:not(.animated) .animable {opacity: 0;}svg#freepik_stories-discussion.animated #freepik--background-complete--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--Shadow--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--character-3--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--character-2--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--character-1--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--speech-bubble-3--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--speech-bubble-2--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--speech-bubble-1--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-discussion.animated #freepik--Table--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "eldgb7mf78xeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "el71jnirg5z8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "el2r4fe0qby4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elpihwwrvp1t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "el9eviisgclj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "elfsli8ofpap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el9nahqknghdl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "elbk95qbsvhf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "elui8phqbtz9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,325.06a.49.49,0,0,1-.17-.36c-.12-2.53-1.64-27.4-16.87-44.43-12.88-14.41.33-4.12,6.07.51a.53.53,0,0,0,.79-.68c-4-6.83-14.18-24.89-10.67-28.41,3.33-3.32,10.19,13.17,13.26,21.17a.53.53,0,0,0,1-.24c-.88-8.47-2.17-26.18,2.6-25.55s3.4,24,2.47,35.45a.53.53,0,0,0,1,.2c2.13-7,6.18-17.45,10.94-14.7,7.05,4.09-10.37,18.42-9.28,34C289.25,317.25,289.53,327.26,287,325.06Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "281.804px 286.208px"
    },
    id: "el9rzv31x97w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.12,327.36c.05,0,.12-.24.09-.41-3.32-21.07,19-36.39,34.66-44,3.49-1.69,7.11-3.43,10.08-6-5.8.38-11.6,2.82-17.17,4.68-.73.25-1.12-.51-.48-.95,7.1-4.94,26.89-23.09,21.19-28.38-2.57-2.39-16.78,16.56-20.13,20-.54.55-1.4.06-1-.58,4.41-7.38,5.87-30.66,1.4-30.38-1.89.12-2.61,11-3.6,15.47-1.86,8.31-5.35,16.12-9,23.77-.33.67-1.45.56-1.28-.12,1.27-5.09,1.74-20-4.53-18.94-4.54.78-3.81,9.57-3.85,14.28-.08,8.36-.78,16.93-4.38,24.37C295.66,305.22,292.61,327.78,296.12,327.36Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "320.019px 284.352px"
    },
    id: "elsf59fhfo8og",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.07,329.69a.3.3,0,0,0,.11-.24c.08-1.7,1.1-18.39,11.32-29.82,8.65-9.67-.22-2.77-4.07.34a.36.36,0,0,1-.53-.46c2.71-4.58,9.52-16.7,7.16-19.06s-6.84,8.84-8.9,14.21a.35.35,0,0,1-.68-.17c.59-5.68,1.45-17.57-1.75-17.15s-2.28,16.12-1.66,23.8a.35.35,0,0,1-.69.14c-1.43-4.73-4.16-11.72-7.35-9.87-4.73,2.74,7,12.36,6.23,22.81C289.54,324.45,289.35,331.17,291.07,329.69Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "294.534px 303.612px"
    },
    id: "el1r14myl0wce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.59,376.61c5.26-19.62,8.73-47.26,8.73-54.06H272.06c0,6.8,3.47,34.44,8.73,54.06a8.25,8.25,0,0,0,8,6.11h5.84A8.26,8.26,0,0,0,302.59,376.61Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "291.69px 352.635px"
    },
    id: "elezsdk4d7hkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.18,335.54c.3-2.39.53-4.56.72-6.47H272.48c.18,1.91.42,4.08.71,6.47Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "291.69px 332.305px"
    },
    id: "elyqtb9j4tg3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu2z1gwflfvb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.72,
    y: 209.79,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "135.595px 231.3px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el30u5xnkag67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 213.94,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "135.6px 231.295px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,213.94a2.87,2.87,0,0,1-2.84,2.08H130.48a2.87,2.87,0,0,1-2.84-2.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "135.595px 214.981px"
    },
    id: "eljcy97lkxib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8rgamsjczak"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.72,
    y: 252.81,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "135.595px 274.32px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf24u0xac1s"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 256.96,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "135.6px 274.315px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,257a2.86,2.86,0,0,1-2.84,2.07H130.48a2.86,2.86,0,0,1-2.84-2.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "135.595px 258.036px"
    },
    id: "elfntrt28rt47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqa7c1i80u7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.72,
    y: 295.83,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "135.595px 317.34px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm2qryg10esb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 299.98,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "135.6px 317.335px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,300a2.86,2.86,0,0,1-2.84,2.07H130.48a2.86,2.86,0,0,1-2.84-2.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "135.595px 301.036px"
    },
    id: "elg38v601217s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7k7anoeeh2i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.72,
    y: 338.84,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "135.595px 360.35px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm9gkvyt9q3k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.33,
    y: 342.99,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "135.6px 360.345px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,343a2.87,2.87,0,0,1-2.84,2.08H130.48a2.87,2.87,0,0,1-2.84-2.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "135.595px 344.041px"
    },
    id: "ela420xp9ants",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3b706vt688a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.87,
    y: 209.79,
    width: 5.85,
    height: 172.07,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "108.795px 295.825px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elccrjqcnp8g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 209.79,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "86.275px 231.3px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfte0j31rr4e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.01,
    y: 213.94,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "86.28px 231.295px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,213.94A2.86,2.86,0,0,1,91.4,216H81.16a2.85,2.85,0,0,1-2.83-2.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.28px 214.961px"
    },
    id: "elb04iws9jriu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6jx6o05m2r5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 252.81,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "86.275px 274.32px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1mnofbcr9x7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.01,
    y: 256.96,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "86.28px 274.315px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,257A2.86,2.86,0,0,1,91.4,259H81.16A2.85,2.85,0,0,1,78.33,257Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.28px 258.001px"
    },
    id: "elq7qfeo3by2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsslex1ol13c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 295.83,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "86.275px 317.34px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt92xul2y4bb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.01,
    y: 299.98,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "86.28px 317.335px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,300a2.86,2.86,0,0,1-2.84,2.07H81.16A2.85,2.85,0,0,1,78.33,300Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.28px 301.036px"
    },
    id: "elxl4s7o0r8v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhmel8gyvkeo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 338.84,
    width: 47.75,
    height: 43.02,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "86.275px 360.35px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm9u71b68q9j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.01,
    y: 342.99,
    width: 38.54,
    height: 34.71,
    rx: 4.6,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "86.28px 360.345px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,343a2.87,2.87,0,0,1-2.84,2.08H81.16A2.85,2.85,0,0,1,78.33,343Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "86.28px 344.041px"
    },
    id: "el526afv0jzz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell61x5cpkkci"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.55,
    y: 209.79,
    width: 5.85,
    height: 172.07,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "59.475px 295.825px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 317.43,
    y: 97.33,
    width: 1.8,
    height: 140.37,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "318.33px 167.515px"
    },
    id: "elz1o2vke4xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.48,
    y: 97.33,
    width: 1.8,
    height: 140.37,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.38px 167.515px"
    },
    id: "elg1k59ay3je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 106.16 310.38 106.16 307.69 99.86 441.04 99.86 438.33 106.16",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 103.01px"
    },
    id: "el2s8ygezlaef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 114.81 310.38 114.81 307.69 108.51 441.04 108.51 438.33 114.81",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 111.66px"
    },
    id: "elmjugne591sa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 123.46 310.38 123.46 307.69 117.16 441.04 117.16 438.33 123.46",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 120.31px"
    },
    id: "elr0iond0jaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 132.11 310.38 132.11 307.69 125.81 441.04 125.81 438.33 132.11",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 128.96px"
    },
    id: "el5w98x3mg4qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 140.75 310.38 140.75 307.69 134.46 441.04 134.46 438.33 140.75",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 137.605px"
    },
    id: "el4f2rx4jls4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 149.4 310.38 149.4 307.69 143.1 441.04 143.1 438.33 149.4",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 146.25px"
    },
    id: "elbfj8mrxjmpk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 158.05 310.38 158.05 307.69 151.75 441.04 151.75 438.33 158.05",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 154.9px"
    },
    id: "elrz46u5dq5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 166.7 310.38 166.7 307.69 160.4 441.04 160.4 438.33 166.7",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 163.55px"
    },
    id: "elxv1366s5cbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 175.35 310.38 175.35 307.69 169.05 441.04 169.05 438.33 175.35",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 172.2px"
    },
    id: "elb5ut3jziym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 184 310.38 184 307.69 177.7 441.04 177.7 438.33 184",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 180.85px"
    },
    id: "elfcrdy7y00y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 192.65 310.38 192.65 307.69 186.35 441.04 186.35 438.33 192.65",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 189.5px"
    },
    id: "elgeec2i9b01t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 201.3 310.38 201.3 307.69 195 441.04 195 438.33 201.3",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 198.15px"
    },
    id: "el54qmvylv7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 209.95 310.38 209.95 307.69 203.65 441.04 203.65 438.33 209.95",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 206.8px"
    },
    id: "ely9uuw3mcnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 218.6 310.38 218.6 307.69 212.3 441.04 212.3 438.33 218.6",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 215.45px"
    },
    id: "elw4jnzw16seq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 227.25 310.38 227.25 307.69 220.95 441.04 220.95 438.33 227.25",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 224.1px"
    },
    id: "elz3xvivzwshh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.33 235.9 310.38 235.9 307.69 229.6 441.04 229.6 438.33 235.9",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "374.365px 232.75px"
    },
    id: "elblnvde4orp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.68,
    y: 235.9,
    width: 133.35,
    height: 3.6,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.355px 237.7px"
    },
    id: "eldgd7sya76kw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.03,
    y: 91.97,
    width: 142.65,
    height: 8.4,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.355px 96.17px"
    },
    id: "elmfwkg9kkszg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,176.53h0a1.45,1.45,0,0,1-1.45-1.45v-49a1.45,1.45,0,0,1,1.45-1.45h0a1.45,1.45,0,0,1,1.45,1.45v49A1.45,1.45,0,0,1,304.5,176.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "304.5px 150.58px"
    },
    id: "el7ly489dcnc6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.97,
    y: 98.68,
    width: 1.05,
    height: 29.1,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "304.495px 113.23px"
    },
    id: "el6i3gho6lrle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.32,
    y: 90.52,
    width: 163.83,
    height: 99.83,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "136.235px 140.435px"
    },
    id: "elmcy1imlbqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.16,
    y: 90.48,
    width: 1.2,
    height: 99.83,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "218.76px 140.395px"
    },
    id: "el0oclxojxf9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.28,
    y: 94.86,
    width: 0.99,
    height: 89.83,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.775px 139.775px"
    },
    id: "elcvp6jwogc1v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.18,
    y: 94.86,
    width: 153.63,
    height: 89.83,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "135.995px 139.775px"
    },
    id: "el4vkexh0koha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.52,
    y: 124.79,
    width: 12.66,
    height: 18.18,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "156.85px 133.88px"
    },
    id: "elob7joouil5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.58,
    y: 153.61,
    width: 12.66,
    height: 18.18,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "72.91px 162.7px"
    },
    id: "elzpsrs2dl40r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.34,
    y: 115.68,
    width: 12.66,
    height: 12.66,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "71.67px 122.01px"
    },
    id: "eltqa4ynymsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.32,
    y: 159.4,
    width: 12.66,
    height: 12.66,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "134.65px 165.73px"
    },
    id: "elncxgbemnqia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.74,
    y: 126.36,
    width: 32.42,
    height: 45.56,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "186.95px 149.14px"
    },
    id: "el6pferu1732c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.18,
    y: 132.96,
    width: 23.29,
    height: 0.5,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.825px 133.21px"
    },
    id: "elvxl72inm1yc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.57,
    y: 133.44,
    width: 0.5,
    height: 33.74,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.82px 150.31px"
    },
    id: "elwdxpikhd6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.26,
    y: 133.44,
    width: 0.5,
    height: 33.74,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "197.51px 150.31px"
    },
    id: "el8u9c96zhedj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.07,
    y: 133.44,
    width: 0.5,
    height: 33.74,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "177.32px 150.31px"
    },
    id: "el1s615t4tqqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.4,
    y: 133.44,
    width: 0.5,
    height: 33.74,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "175.65px 150.31px"
    },
    id: "el2hv86tsq07r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.65,
    y: 135.22,
    width: 21.62,
    height: 0.5,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "186.46px 135.47px"
    },
    id: "el5geqqs6cvjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm8nm2ngjk9f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.84,
    y: 109.76,
    width: 4.28,
    height: 9.98,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "122.98px 114.75px",
      transform: "rotate(-90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elttkccfy14op"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.27,
    y: 141.49,
    width: 3.33,
    height: 9.98,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "124.935px 146.48px",
      transform: "rotate(-90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.14,
    y: 111.21,
    width: 32.42,
    height: 45.56,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "105.35px 133.99px"
    },
    id: "el1n4pon6e2nmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt6xoe7t1b4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.03,
    y: 148.86,
    width: 3.33,
    height: 9.98,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "122.695px 153.85px",
      transform: "rotate(-90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elffgvodhdazj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.69,
    y: 118.41,
    width: 3.33,
    height: 9.98,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "124.355px 123.4px",
      transform: "rotate(-90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el091n5et5oal9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 126.67,
    width: 3.33,
    height: 9.98,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "122.165px 131.66px",
      transform: "rotate(-90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.96,
    y: 116.81,
    width: 22.1,
    height: 3.92,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "104.01px 118.77px"
    },
    id: "el6zl2tmj1vm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.41 133.56 93.31 133.56 92.96 131.78 115.06 131.78 115.41 133.56",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "104.185px 132.67px"
    },
    id: "eluulsdxeo5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.96,
    y: 124.65,
    width: 7.84,
    height: 3.92,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "96.88px 126.61px"
    },
    id: "elfmrbped6e2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpsc7s61ipis"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 261.67,
    cy: 84.76,
    r: 20.45,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.67px 84.76px",
      transform: "rotate(-80.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwlrye48mazi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 261.42,
    cy: 84.76,
    r: 16.41,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "261.42px 84.76px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263,86.12a1.67,1.67,0,0,1-3.33,0,1.67,1.67,0,1,1,3.33,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.335px 85.9908px"
    },
    id: "elkcnz3wu6ty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.19 86.73 254.13 80.08 254.81 79.36 261.21 85.38 272.67 75.25 273.34 76 261.19 86.73",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "263.735px 80.99px"
    },
    id: "elf5ns12pip1r",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-5",
    className: "animable",
    style: {
      transformOrigin: "250px 415.69px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-5",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 415.69px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-5",
    className: "animable",
    style: {
      transformOrigin: "358.57px 314.324px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.57,350.89h32.91a121.76,121.76,0,0,1-12.69,4.28v5.33h-7.54v-5.33A121.22,121.22,0,0,1,354.57,350.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.025px 355.695px"
    },
    id: "elz1wa5gz47v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.85,337.21H390.6a72.63,72.63,0,0,0,0-23.54h11.25A72.63,72.63,0,0,1,401.85,337.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.705px 325.44px"
    },
    id: "el9vakibi7le6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.14,
    y: 360.5,
    width: 9.77,
    height: 39.38,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.025px 380.19px"
    },
    id: "elq2ykb4zxl6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfpcghudfrog"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.14,
    y: 360.5,
    width: 9.77,
    height: 39.38,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "371.025px 380.19px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.63,316.37H372.12a8.86,8.86,0,0,1-8.81-10.52c2.33-17.5,3.56-30,3.73-47.63a8.78,8.78,0,0,1,8.92-9.08h40.83a11,11,0,0,1,10.65,9.08c2.4,17.5,3.71,30,3.95,47.63A10.9,10.9,0,0,1,420.63,316.37Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "397.271px 282.755px"
    },
    id: "el8v7rl7v27ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,305.85c-.24-17.66-1.55-30.13-4-47.63a11,11,0,0,0-10.65-9.08H376a8.78,8.78,0,0,0-8.92,9.08c-.17,17.66-1.4,30.13-3.73,47.63a8.86,8.86,0,0,0,8.81,10.52H412A10.9,10.9,0,0,0,422.79,305.85Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "392.991px 282.755px"
    },
    id: "elsiofg1vg4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrroii03bzmq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.79,305.85c-.24-17.66-1.55-30.13-4-47.63a11,11,0,0,0-10.65-9.08H376a8.78,8.78,0,0,0-8.92,9.08c-.17,17.66-1.4,30.13-3.73,47.63a8.86,8.86,0,0,0,8.81,10.52H412A10.9,10.9,0,0,0,422.79,305.85Z",
    style: {
      opacity: 0.1,
      transformOrigin: "392.991px 282.755px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.18,405.38a1.45,1.45,0,0,1-1.75,1.42c-5.31-1.16-21.2-4.51-27.41-4.51s-22.09,3.35-27.4,4.51a1.45,1.45,0,0,1-1.75-1.42h0a3.79,3.79,0,0,1,3-3.71c6.21-1.34,20.38-4.24,26.15-4.24s20,2.9,26.16,4.24a3.79,3.79,0,0,1,3,3.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.025px 402.131px"
    },
    id: "elv3c7xnj24fp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.69,409.27a3.83,3.83,0,1,0,3.83-3.83,3.83,3.83,0,0,0-3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.52px 409.27px"
    },
    id: "elqv4c75044zk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,409.27a3.83,3.83,0,1,1-3.83-3.83,3.83,3.83,0,0,1,3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.68px 409.27px"
    },
    id: "elxpv28y6lk0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.44,408a3.83,3.83,0,1,1-3.83-3.83,3.84,3.84,0,0,1,3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.61px 408px"
    },
    id: "elp9dxferyrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.79,336.47a397.5,397.5,0,0,1-58.24-2.06,6.3,6.3,0,0,0-7.19,6.38v.95a8.27,8.27,0,0,0,7.19,8.05,397.5,397.5,0,0,0,58.24,2Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "353.074px 343.22px"
    },
    id: "elgvzrx7p7jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrm88pdrja6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.79,336.47a397.5,397.5,0,0,1-58.24-2.06,6.3,6.3,0,0,0-7.19,6.38v.95a8.27,8.27,0,0,0,7.19,8.05,397.5,397.5,0,0,0,58.24,2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "353.074px 343.22px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.88,349.75c-11.13,1-22.09,1.77-33.25,2.22a6.68,6.68,0,0,1-6.85-6.71v-1.71a7,7,0,0,1,6.85-6.95c11.16-.45,22.12-1.19,33.25-2.23a6,6,0,0,1,6.81,6v1.71A7.86,7.86,0,0,1,414.88,349.75Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "398.235px 343.144px"
    },
    id: "eleogi10olpvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.9 381.82 302.15 382.4 308.86 360.33 315.32 369.79 309.9 381.82",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "308.735px 371.365px"
    },
    id: "el7gy7920v75p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt91nksi8wx"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "310.85px 366.615px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "309.01 360.03 306.22 369.43 313.8 373.2 315.48 369.49 309.01 360.03",
    id: "ely1qfb3okju8",
    className: "animable",
    style: {
      transformOrigin: "310.85px 366.615px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M311,380.06a6.6,6.6,0,0,1-.28,3c-1.12,3.57-4.28,13-4.28,13l-.8-.23s1.21-4.75,1.52-7.24-.77-.64-2.86,1.44-6.32,3.44-11.51,2.08c-6.08-1.6-8.44-2.59-6.22-3.64s6.51-.9,6.51-.9a19.24,19.24,0,0,0,10.66-13.15c.56-2.26,1.5-2,2.61-.87a24.47,24.47,0,0,0,5.67,4.28A11.7,11.7,0,0,0,311,380.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "298.885px 384.382px"
    },
    id: "elvyrpgoxpfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.22 390.8 355.79 396.37 346.19 375.4 357.31 378.2 361.22 390.8",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "353.705px 385.885px"
    },
    id: "eleu6gpwvh6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo5okgr6gwje"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "352.27px 379.515px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.11 375.07 350.25 383.96 358.43 381.76 357.22 377.87 346.11 375.07",
    id: "elbd14enf2khe",
    className: "animable",
    style: {
      transformOrigin: "352.27px 379.515px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M360.86,388.77a6.67,6.67,0,0,1,1.79,2.44c1.54,3.42,5.42,12.59,5.42,12.59l-.75.35s-2.25-4.35-3.66-6.42-1,0-1.19,3-2.45,6.76-7.24,9.18c-5.62,2.84-8,3.66-7.07,1.4s4.28-5,4.28-5a19.24,19.24,0,0,0-.74-16.91c-1.08-2.07-.22-2.51,1.39-2.38a24.18,24.18,0,0,0,7.07-.56A12,12,0,0,0,360.86,388.77Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "358.017px 399.536px"
    },
    id: "el100tupaqqzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,336.58h-39c6.36,4.54,13.85,42,13.85,42l-10.5,3.64s-3-6.46-8.63-21.8c-2.86-7.76-6.31-15.72-8.33-23.52v0a55.13,55.13,0,0,1-1.43-7.31q-.07-.56-.12-1.11c0-.24,0-.48,0-.71s0-.4,0-.6V327c0-.16,0-.32.07-.48l0-.12a4.21,4.21,0,0,1,.12-.48.14.14,0,0,1,0-.07,5.05,5.05,0,0,1,.18-.55l0-.1a5.05,5.05,0,0,1,.24-.53.31.31,0,0,1,.05-.1c.08-.16.17-.31.26-.46a8.59,8.59,0,0,1,.72-1l.09-.1.41-.45a11,11,0,0,1,1-.92.1.1,0,0,1,.05,0l.58-.45.62-.44.66-.42c.45-.27.93-.54,1.43-.79,0,0,0,0,.05,0l1.33-.63.46-.2s.05,0,.06,0h0c4.36,1.41,12.37,5.06,21,8.72,9.71,4.14,20.16,8.27,26.89,9.13A15.44,15.44,0,0,1,383.44,336.58Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "357.415px 350.465px"
    },
    id: "el9juyg1hvzcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz2il7cjezo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.44,336.58h-39c6.36,4.54,13.85,42,13.85,42l-10.5,3.64s-3-6.46-8.63-21.8c-2.86-7.76-6.31-15.72-8.33-23.52v0a55.13,55.13,0,0,1-1.43-7.31q-.07-.56-.12-1.11c0-.24,0-.48,0-.71s0-.4,0-.6V327c0-.16,0-.32.07-.48l0-.12a4.21,4.21,0,0,1,.12-.48.14.14,0,0,1,0-.07,5.05,5.05,0,0,1,.18-.55l0-.1a5.05,5.05,0,0,1,.24-.53.31.31,0,0,1,.05-.1c.08-.16.17-.31.26-.46a8.59,8.59,0,0,1,.72-1l.09-.1.41-.45a11,11,0,0,1,1-.92.1.1,0,0,1,.05,0l.58-.45.62-.44.66-.42c.45-.27.93-.54,1.43-.79,0,0,0,0,.05,0l1.33-.63.46-.2s.05,0,.06,0h0c4.36,1.41,12.37,5.06,21,8.72,9.71,4.14,20.16,8.27,26.89,9.13A15.44,15.44,0,0,1,383.44,336.58Z",
    style: {
      opacity: 0.4,
      transformOrigin: "357.415px 350.465px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.62,336.43c-6.73-.86-17.18-5-26.89-9.13-8.58-3.66-16.59-7.31-21-8.72,13-5.45,36.18-5.32,36.18-5.32s6-5.7,12.67-7.06a14,14,0,0,1,2.73-.29l.19.26C401.13,321.61,396.87,334.93,385.62,336.43Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "367.068px 321.17px"
    },
    id: "elup9av2r0k7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,285.2c5.66,5.18,16.81-7.08,18.6-8.54,3.84-3.13,15.13-13.68,14.53-17.34-1.76-10.77-19.45,4.49-24.55,15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.037px 271.053px"
    },
    id: "el7dfsm8fdx52",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.09,252.79c2.84.61,5.92-.42,7.92,1.69s2.84,5.07,3.13,8a53.23,53.23,0,0,1-.63,12.08q-.93,7.29-1.88,14.58a43.88,43.88,0,0,0,.46,12v0a1.94,1.94,0,0,1-1.1,2.09s-22.07.76-28.49.52c-3.41-.13-1.07-9.1-2.11-14.33-.23-1.16-2.52-5.95-2.86-7.18-1.58-5.79-.53-9.77.94-15.59,1.07-4.23,1.5-10.33,3.66-10.79C374,255,383.17,251.11,391.09,252.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.492px 278.085px"
    },
    id: "el468msswzt6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.25,256.93c.29-.44,8.05-7,9.46.57,2,10.51-2.1,20.85-2.1,20.85s-.93,11.37-4.23,12.51-6.45,1.41-7.56-.53a11.57,11.57,0,0,1-1.11-4.86S389.1,264.78,394.25,256.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.485px 272.813px"
    },
    id: "elox320i26sh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.87,238.37c-.8,4.84-1.48,13.68,2,16.79a45.41,45.41,0,0,0-14,12.14,7.32,7.32,0,0,1-2.57-8.16,7.16,7.16,0,0,1,3.56-4.3c3.28-1.8,3-5.18,2.07-8.36Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "382.4px 252.835px"
    },
    id: "elhkidirllczr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2pa8dl0aek3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.77,246.58l-3.16,1.21a10.51,10.51,0,0,1-4.23.69h0a6.85,6.85,0,0,1,0,3,6,6,0,0,0,6.26-2A10.6,10.6,0,0,0,387.77,246.58Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "384.075px 249.139px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.27,303.29l.92,2.92c.13.23-.13.47-.52.48l-33.24,1c-.3,0-.54-.13-.57-.32l-.38-2.94c0-.2.22-.38.54-.4l32.67-1A.6.6,0,0,1,400.27,303.29Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "383.852px 305.357px"
    },
    id: "elwxlh4hqjjih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.32,324.1a7.57,7.57,0,0,1,.72-1A8.59,8.59,0,0,0,330.32,324.1Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "330.68px 323.6px"
    },
    id: "eljp5mooenz4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.53,321.61a11,11,0,0,0-1,.92A8.75,8.75,0,0,1,332.53,321.61Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "332.03px 322.07px"
    },
    id: "elsjjlq506xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8hvhlnh5vu5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.32,324.1a7.57,7.57,0,0,1,.72-1A8.59,8.59,0,0,0,330.32,324.1Z",
    style: {
      opacity: 0.6,
      transformOrigin: "330.68px 323.6px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el00dyk4zkc56yd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.53,321.61a11,11,0,0,0-1,.92A8.75,8.75,0,0,1,332.53,321.61Z",
    style: {
      opacity: 0.6,
      transformOrigin: "332.03px 322.07px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.14,281.79a13.48,13.48,0,0,1-4.18-6.7,13.87,13.87,0,0,1-.19-2.79,156,156,0,0,1,1.68-16.38l4.7-1.55s1.46,8.06,1.78,12.49c.07.87.17,1.9.27,3,.21,2,.46,4.15.69,6Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "344.326px 268.08px"
    },
    id: "el3ygt2mthsxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.45,285.2c-1.44-1.32-1.68-2.92-2.43-6.32-.71-3.22.09-7.14.75-6.58a.71.71,0,0,1,.19.28c1.13,2.69,5.57.33,6.83-1a9.54,9.54,0,0,0,1.41-1.73,1.45,1.45,0,0,0,0-1.63c1.36-.57,2.45,4.8,1.8,6.12l-.33,1a13.7,13.7,0,0,1-2.47,4.43l-2.47,3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "344.468px 276.689px"
    },
    id: "eluny485kc2c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,255.06l.56-8.2a33,33,0,0,1-4.53,1.75c-2.28.78-5.36-.6-4.67.89a64.14,64.14,0,0,0,3.82,6.42Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "342.181px 251.39px"
    },
    id: "el1li10ea5yae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.83,246.86l-3.49-8.21-4.59,2.81c-1.27,2.75-1.12,8-1.12,8S344,249.78,346.83,246.86Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "342.227px 244.06px"
    },
    id: "el0id90i0qrh5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63,224.58c-3.5,6.63-2.65,15,1.07,21.55,6.37-4.32,15.62-.88,22.18-4.85,4.38-2.66,6.45-8.4,5.32-13.4-1.21-5.4-7.06-11.72-12.74-12.27C380.09,215,373.58,219,370.63,224.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.957px 230.839px"
    },
    id: "el22wioyaxd3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.22,227.2a10.19,10.19,0,0,0-13.16-5.9c-7.44,2.78-8.83,13.88-7.44,20.7,1.5,7.6,10.6,10.06,16.49,4.37,3.93-3.78,4.05-7,4.73-14.49A10.36,10.36,0,0,0,392.22,227.2Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "382.015px 235.061px"
    },
    id: "elllarbdowhf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.08,239.36a2.63,2.63,0,0,1-2.17-.47,16,16,0,0,0,2.3-3.86Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "375.06px 237.227px"
    },
    id: "eleyasg1nbpo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.78,240.06a.17.17,0,0,0,0-.25.18.18,0,0,0-.25,0,4.81,4.81,0,0,1-4,1.8.19.19,0,0,0-.18.17h0a.16.16,0,0,0,.17.17,5.06,5.06,0,0,0,4.31-1.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.592px 240.86px"
    },
    id: "elxqybcq8nos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,218.4a7.6,7.6,0,0,0-1.79,2.77c8,4,12.1,14.31,12.48,23.32,3-2.46,8.37-5.07,11-8.27,2.92-3.59,1.44-8.86-1.93-12a71.14,71.14,0,0,0-9.7-6.8A8.21,8.21,0,0,0,381.52,218.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.251px 230.315px"
    },
    id: "elpix3nc8g6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,237a2.48,2.48,0,0,0-2.38-2.56c-1.88,0-3.12,2.31-3.4,3.94-.28,1.8.81,3.35,2.59,2.61a5.49,5.49,0,0,0,2.94-3A2.54,2.54,0,0,0,395,237Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "392.089px 237.81px"
    },
    id: "elut9ejfgi8kt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.22,233c0,.75-.37,1.37-.86,1.39s-.91-.58-.92-1.35.37-1.37.85-1.39S381.2,232.21,381.22,233Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.33px 233.02px"
    },
    id: "elphodyt5mpve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.21,233.74c0,.75-.36,1.37-.85,1.39s-.91-.58-.93-1.34.37-1.38.86-1.4S374.2,233,374.21,233.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.32px 233.76px"
    },
    id: "elloe3b7i4h1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.51,232.43l-1.82-.47S372.65,233.35,373.51,232.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.6px 232.352px"
    },
    id: "el5pmfdd1te1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,230.09a.46.46,0,0,0,.17-.09.38.38,0,0,0,0-.53h0a4.26,4.26,0,0,0-3.71-1.37.38.38,0,0,0-.3.43.36.36,0,0,0,.42.29A3.63,3.63,0,0,1,383,230,.36.36,0,0,0,383.34,230.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.557px 229.083px"
    },
    id: "elybnw25jkbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.54,231.36a.29.29,0,0,0,.14-.13,3.63,3.63,0,0,1,2.86-1.59.37.37,0,0,0,.39-.35h0a.38.38,0,0,0-.36-.38,4.38,4.38,0,0,0-3.49,1.91.37.37,0,0,0,.06.52.38.38,0,0,0,.4,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.965px 230.153px"
    },
    id: "ell6jchaogd6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.51,231.66l-1.82-.47S379.66,232.58,380.51,231.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.6px 231.582px"
    },
    id: "elgu7l4r4cpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,235.12c-.23,4.64,1.91,11.65,5.19,14.92-3.06,1.35-7.16-2-9.48-4.38a11.85,11.85,0,0,1-2.95-9.23,20,20,0,0,1,3.56-9.23c3-4.56,7.52-7.69,12.45-10,1-.47,2.53-.67,2.85.37.22.72-.39,1.4-.95,1.91C374.87,224.33,370.76,227.64,369.59,235.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.766px 233.584px"
    },
    id: "elw45v77n2cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.74,248.05l-.06,0a.27.27,0,0,1-.12-.37c5.68-11-4.71-22.91-8-26.3a.28.28,0,0,1,.39-.39c3.39,3.46,14,15.62,8.13,26.94A.27.27,0,0,1,387.74,248.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.663px 234.505px"
    },
    id: "elr4odwh3bz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.96 240.11 390.74 244.19 391.62 245.35 392.46 244.22 391.96 240.11",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "391.6px 242.73px"
    },
    id: "elszy75kh551p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.45,250.46c0-.26-.07-.61-.1-1a3.41,3.41,0,0,1,2.78-3.64h.05a1.42,1.42,0,0,0,1.08-.93c.62-1.79.86-2.34,1.45-4.1,1.62-.39,3.53.21,5.2.39a14.31,14.31,0,0,1,.09,6.11,2.66,2.66,0,0,1-.51,1.25,21.58,21.58,0,0,1-5,3.07C395,252.06,393,250.61,391.45,250.46Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "396.812px 246.179px"
    },
    id: "el7fagr2bmm2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.29,251.67s4.41,28.44-.13,32.77c-2.67,2.55-5,1.14-6.42-.45a5.67,5.67,0,0,1-1.39-4.38l3.1-29.15S394.51,248.69,396.29,251.67Z",
    style: {
      fill: "rgb(232, 191, 191)",
      transformOrigin: "393.264px 267.89px"
    },
    id: "elbuusvsxsnen",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.12,334.27a18.61,18.61,0,0,1-4,1.55c-.35.09-.71.18-1.07.25a24.14,24.14,0,0,1-5.13.53,15,15,0,0,1-1.71-.1l-.62-.07-.64-.09c-.63-.1-1.28-.22-2-.36s-1.5-.34-2.29-.55l-.77-.21q-1.47-.41-3-.9l-1.05-.34c-2-.65-4-1.4-6.14-2.2l-.83-.32c-2.68-1-5.41-2.16-8.11-3.29l-2.06-.87c-8.58-3.66-16.59-7.31-21-8.72h0s0,0-.06,0l-.46.2-1.33.63s0,0-.05,0c-.5.25-1,.52-1.43.79l-.66.42-.62.44-.58.45a.1.1,0,0,0-.05,0,11,11,0,0,0-1,.92l-.41.45-.09.1a8.59,8.59,0,0,0-.72,1c-.09.15-.18.3-.26.46a.31.31,0,0,0-.05.1,5.05,5.05,0,0,0-.24.53l0,.1a5.05,5.05,0,0,0-.18.55.14.14,0,0,0,0,.07,4.21,4.21,0,0,0-.12.48l0,.12c0,.16-.05.32-.07.48v.15q0,.3,0,.6c0,.23,0,.47,0,.71s.07.74.12,1.11a55.13,55.13,0,0,0,1.43,7.31c-1.41,3.49-2.84,6.93-4.24,10.21l-1.38,3.22c-1.59,3.7-3.11,7.13-4.45,10.14q-.3.65-.57,1.26l-1.56,3.45c-.17.35-.32.7-.47,1l-1.8,3.9c-.07.14-.14.28-.2.42s-.12.26-.18.38-.11.23-.16.34c-.41.87-.28.58-.28.58L306,366.31s7.13-25.25,11.77-48.56a20.6,20.6,0,0,1,17.84-16.49c18.26-2.08,43.42,5.06,43.42,5.06h1.7l4-.06,1.91,0H387l1.6,0H391c3.18,0,6.44-.06,9,0C408.82,321.25,405.46,330.32,398.12,334.27Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "355.638px 336.288px"
    },
    id: "elhs0axxquvf4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2ej1j0detvp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "355.638px 336.288px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.12,334.27a18.61,18.61,0,0,1-4,1.55c-.35.09-.71.18-1.07.25a24.14,24.14,0,0,1-5.13.53,15,15,0,0,1-1.71-.1l-.62-.07-.64-.09c-.63-.1-1.28-.22-2-.36s-1.5-.34-2.29-.55l-.77-.21q-1.47-.41-3-.9l-1.05-.34c-2-.65-4-1.4-6.14-2.2l-.83-.32c-2.68-1-5.41-2.16-8.11-3.29l-2.06-.87c-8.58-3.66-16.59-7.31-21-8.72h0s0,0-.06,0l-.46.2-1.33.63s0,0-.05,0c-.5.25-1,.52-1.43.79l-.66.42-.62.44-.58.45a.1.1,0,0,0-.05,0,11,11,0,0,0-1,.92l-.41.45-.09.1a8.59,8.59,0,0,0-.72,1c-.09.15-.18.3-.26.46a.31.31,0,0,0-.05.1,5.05,5.05,0,0,0-.24.53l0,.1a5.05,5.05,0,0,0-.18.55.14.14,0,0,0,0,.07,4.21,4.21,0,0,0-.12.48l0,.12c0,.16-.05.32-.07.48v.15q0,.3,0,.6c0,.23,0,.47,0,.71s.07.74.12,1.11a55.13,55.13,0,0,0,1.43,7.31c-1.41,3.49-2.84,6.93-4.24,10.21l-1.38,3.22c-1.59,3.7-3.11,7.13-4.45,10.14q-.3.65-.57,1.26l-1.56,3.45c-.17.35-.32.7-.47,1l-1.8,3.9c-.07.14-.14.28-.2.42s-.12.26-.18.38-.11.23-.16.34c-.41.87-.28.58-.28.58L306,366.31s7.13-25.25,11.77-48.56a20.6,20.6,0,0,1,17.84-16.49c18.26-2.08,43.42,5.06,43.42,5.06h1.7l4-.06,1.91,0H387l1.6,0H391c3.18,0,6.44-.06,9,0C408.82,321.25,405.46,330.32,398.12,334.27Z",
    id: "elehsoj50mpn6",
    className: "animable",
    style: {
      transformOrigin: "355.638px 336.288px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5",
    className: "animable",
    style: {
      transformOrigin: "252.338px 305.647px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.18,
    y: 364.34,
    width: 9.37,
    height: 39.11,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.865px 383.895px"
    },
    id: "el4zbk6og6b0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellaxsf5ce7n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.18,
    y: 364.34,
    width: 9.37,
    height: 39.11,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "235.865px 383.895px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 232.52,
    y: 339.56,
    width: 6.68,
    height: 24.97,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.86px 352.045px"
    },
    id: "elqon5luuyia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elice68xk17g"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.2 344.19 232.52 346.63 232.52 339.56 239.2 339.56 239.2 344.19",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "235.86px 343.095px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.77,409.27a3.83,3.83,0,1,0,3.83-3.83,3.84,3.84,0,0,0-3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "266.6px 409.27px"
    },
    id: "elr7xadrfbepo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.51,409.27a3.83,3.83,0,1,1-3.83-3.83,3.83,3.83,0,0,1,3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.68px 409.27px"
    },
    id: "elpoam9cvdois",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.69,408a3.83,3.83,0,1,1-3.83-3.83,3.83,3.83,0,0,1,3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.86px 408px"
    },
    id: "elecxu8m2mdl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,404.13a1.85,1.85,0,0,0,1.88,1.49l39.95-.54,37.41.84a1.86,1.86,0,0,0,.42-3.68l-20.43-4a34.74,34.74,0,0,0-6.43-.6H225.19a34.47,34.47,0,0,0-6.42.6l-23,3.68A1.85,1.85,0,0,0,194.34,404.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.887px 401.78px"
    },
    id: "elemwhqdjlt5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.72,339.46v.09H195A9.65,9.65,0,0,1,193.72,339.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "194.36px 339.505px"
    },
    id: "eljw3814c0c7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2,263.06a1.21,1.21,0,0,1,0,.19v68.4H185.9V262.54A11.67,11.67,0,0,1,186,261l-.1,0,.58-9.63a11.44,11.44,0,0,1,3.18-7.26l6.13-6.42,3.16-16a5.33,5.33,0,0,1,5.22-4.3h14.14a5.34,5.34,0,0,1,5,3.6l5.92,17.26,11.29,6.95a11.48,11.48,0,0,1,5.34,8.1l1.47,9.82Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "216.615px 274.52px"
    },
    id: "elya41yduyxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw4z5pf2zgn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.2,263.06a1.21,1.21,0,0,1,0,.19v68.4H194.12V262.54a11.67,11.67,0,0,1,.1-1.56l-.1,0,.58-9.63a11.44,11.44,0,0,1,3.18-7.26L204,237.7l3.16-16a5.33,5.33,0,0,1,5.22-4.3h5.92a5.34,5.34,0,0,1,5,3.6l5.92,17.26,11.29,6.95a11.48,11.48,0,0,1,5.34,8.1l1.47,9.82Z",
    style: {
      opacity: 0.1,
      transformOrigin: "220.72px 274.525px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,342.87H219.61a121.76,121.76,0,0,0,12.69,4.28v5.33h7.54v-5.33A121.22,121.22,0,0,0,252.52,342.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "236.065px 347.675px"
    },
    id: "ele3uate8onio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,328.45a397.64,397.64,0,0,0,58.25-2.06,6.31,6.31,0,0,1,7.19,6.38v1a8.28,8.28,0,0,1-7.19,8,397.64,397.64,0,0,1-58.25,2.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "254.021px 335.223px"
    },
    id: "elwgmmhwb21ai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrfwq3tbuzyh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.3,328.45a397.64,397.64,0,0,0,58.25-2.06,6.31,6.31,0,0,1,7.19,6.38v1a8.28,8.28,0,0,1-7.19,8,397.64,397.64,0,0,1-58.25,2.06Z",
    style: {
      opacity: 0.2,
      transformOrigin: "254.021px 335.223px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.22,341.73c11.12,1,22.08,1.78,33.24,2.22a6.67,6.67,0,0,0,6.85-6.71v-1.7a7,7,0,0,0-6.85-7c-11.16-.45-22.12-1.18-33.24-2.23a6,6,0,0,0-6.82,6v1.7A7.85,7.85,0,0,0,192.22,341.73Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "208.855px 335.103px"
    },
    id: "el7sm3717grh2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,246.09l.93,3.13-1.76,2.6a14.15,14.15,0,0,1-6.47,3.67,3.31,3.31,0,0,1-3.47-1.49l-.37-.59a4,4,0,0,1-.39-.84c-.53-1.62-.06-2.59,1.24-3.68l4.44-4.66a57.51,57.51,0,0,1,5.78-1.27C284.23,242.91,283.76,245.49,283.7,246.09Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "278.293px 249.258px"
    },
    id: "ely9vkzitata9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.56,266s13.25-13.67,15.77-15.05l.91-.7,4.16,5.26c-.58.59-20.13,34.46-27.53,21.82-1.38-2.37-2.66-4.72-3.83-7.1-.61-1.23-4.31-8.73-4.87-10L239.6,259c-2.69-6-3.68-13,1.87-17.11h0c2.08-.91,5.49,1.56,6.29,4.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.918px 260.926px"
    },
    id: "elpp1a88vqmwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwsbgu85oqt"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "256.918px 260.926px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.56,266s13.25-13.67,15.77-15.05l.91-.7,4.16,5.26c-.58.59-20.13,34.46-27.53,21.82-1.38-2.37-2.66-4.72-3.83-7.1-.61-1.23-4.31-8.73-4.87-10L239.6,259c-2.69-6-3.68-13,1.87-17.11h0c2.08-.91,5.49,1.56,6.29,4.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "256.918px 260.926px"
    },
    id: "elt6slw02uf5k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-102--inject-5",
    className: "animable",
    style: {
      transformOrigin: "273.091px 399.906px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "300.12 387.08 302.69 403.77 295.66 403.77 290.68 387.08 300.12 387.08",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "296.685px 395.425px"
    },
    id: "elrmreg4c58ce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92,402.65l-7.26.16a.54.54,0,0,0-.59.52h0a9.68,9.68,0,0,0-.39,5.25c.28,1.35.67,2.66,1.09,2.67,3.27,0,12,.08,20.67,0,3.63.08,3.63-3.72.83-3.72a21.4,21.4,0,0,1-12.88-4.37A2.52,2.52,0,0,0,302.92,402.65Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "306.88px 406.968px"
    },
    id: "elkuqf3dhdxmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldntyrhqxdwl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "301.36 395.13 300.12 387.08 290.68 387.08 293.62 396.89 301.36 395.13",
    style: {
      opacity: 0.2,
      transformOrigin: "296.02px 391.985px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "244.54 385.68 239.08 399.64 231.38 399.64 234.89 385.88 244.54 385.68",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "237.96px 392.66px"
    },
    id: "elsflr2wsx2rr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3r3h0h2tiyn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "233.31 392.07 234.81 384.47 244.54 385.68 242.05 392.28 233.31 392.07",
    style: {
      opacity: 0.2,
      transformOrigin: "238.925px 388.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.29,398.44l-6.47-3a.55.55,0,0,0-.79,0h0l-4.85,4.3a1.41,1.41,0,0,0,.27,1.95c2.52,1.92,4.24,3.6,7.39,6.07,1.93,1.52,5.56,4.68,8.23,6.78s4.56-.46,3.6-1.56a33.07,33.07,0,0,1-6.57-13.35A2.3,2.3,0,0,0,239.29,398.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "236.914px 405.308px"
    },
    id: "elvzhztji3qd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.08,307c-8.28-22.35-2.84-42.91-3.88-54.29a13,13,0,0,0-10.48-11.56c-5.66-1.1-12.65-2.32-19.32-3.22a12.3,12.3,0,0,0-1.92-.12,13.07,13.07,0,0,0-12.89,13.24C203.17,284.81,214,307,214,307l17.45-.07Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "226.834px 272.404px"
    },
    id: "el77vu1dvxfjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,228.53c-1.19,4.61-1.57,10.35,4.88,12.74,1.79,2.85,2.67,5.86-4.23,4.79a21.18,21.18,0,0,1-13.9-7.87c4.13-3.61,3.37-14.68,2.33-20.93Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "228.601px 231.771px"
    },
    id: "elkm8i775eol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,303.78s40-1.08,40.87,17c1.27,26,5.67,70.52,5.67,70.52l-10.78,2.36s-15.38-43.55-16-63.88c-16.08-3.2-40.24,1.65-45.1-8.91a28.38,28.38,0,0,1-1.83-17.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.807px 348.705px"
    },
    id: "elid8ckhizfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elozl0o8yvv7o"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "264.807px 348.705px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.41,303.78s40-1.08,40.87,17c1.27,26,5.67,70.52,5.67,70.52l-10.78,2.36s-15.38-43.55-16-63.88c-16.08-3.2-40.24,1.65-45.1-8.91a28.38,28.38,0,0,1-1.83-17.12Z",
    id: "elnd6uwpeefc",
    className: "animable",
    style: {
      transformOrigin: "264.807px 348.705px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M240,301.8s27.09,3.81,25.82,21.91c-1.4,19.81-22.16,65.74-22.16,65.74H233.19s7-41.68,10.13-61.87c-14.62,0-23.76,1.91-28.63-8.67a28.3,28.3,0,0,1-1.82-17.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "239.076px 345.62px"
    },
    id: "elptqcxvqkz8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.81,241.56c2.31,1.95,6,5.1,6.66,23.91.2,6-.73,12-.57,18,.18,6.94,1.85,11.82,4.23,18.33,0,1.55-2.34,2.42-4.33,2.83-4.12-9-6.71-17.63-6.55-27.55.56-35.51-10.52-38.82-10.11-40.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.629px 270.81px"
    },
    id: "el901sxqah28g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6u85ve9zldk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.12,231.91a5.76,5.76,0,0,0,4.37,1.06,20.89,20.89,0,0,1,.24-3.35l-7.15-5.88a15.06,15.06,0,0,0-.3,2.31A6.54,6.54,0,0,0,227.12,231.91Z",
    style: {
      opacity: 0.3,
      isolation: "isolate",
      transformOrigin: "227.997px 228.393px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,201.24c7.56,4.27,7.64,16.36,5.31,23.35a10.47,10.47,0,0,1-18.35,3.08c-3.7-4.68-3.17-9.4-3-17.51S230.25,197,237.82,201.24Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "233.063px 215.784px"
    },
    id: "elj78sszydu8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldjpv2wzokb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.57,221.65a28.81,28.81,0,0,0,7,1.41,11.42,11.42,0,0,1-4.13,6.7,10.48,10.48,0,0,1-14.67-2.09c-3-3.83-4-6.42-3.09-13.41A133,133,0,0,0,236.57,221.65Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "232.463px 223.059px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.82,216.63a2.3,2.3,0,0,0-1-1.9,5.47,5.47,0,0,1-1.5-1.61,4.13,4.13,0,0,1-.18-2l.45-5.73c.34-4.42,7.17-1.83,7,1.86-.14,2.52-1.92,2.57-3.4,4.07C222.48,213.1,223.12,214.58,222.82,216.63Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "223.842px 209.847px"
    },
    id: "elrxx5f3gw96c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7986k5x5ors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.82,216.63a2.3,2.3,0,0,0-1-1.9,5.47,5.47,0,0,1-1.5-1.61,4.13,4.13,0,0,1-.18-2l.45-5.73c.34-4.42,7.17-1.83,7,1.86-.14,2.52-1.92,2.57-3.4,4.07C222.48,213.1,223.12,214.58,222.82,216.63Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "223.842px 209.847px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.57,213.4c2.27.51,3.23,3.77,3.17,5.86,0,2.37-1.76,3.92-3.73,2.49a7.37,7.37,0,0,1-2.84-4.56C216.77,214.94,218.3,212.89,220.57,213.4Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "220.425px 217.81px"
    },
    id: "elgt12w3jm1ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58,210.84A4.6,4.6,0,0,1,236,210h0a.37.37,0,0,0,.42-.31.41.41,0,0,0-.33-.46,5.27,5.27,0,0,0-4,1.09h0a.37.37,0,0,0,0,.54.34.34,0,0,0,.17.11A.36.36,0,0,0,232.58,210.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.198px 210.076px"
    },
    id: "elm6t7ey7z7lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,212.5l0,0a.37.37,0,0,0,.11-.51,4.06,4.06,0,0,0-3-2h0a.36.36,0,0,0-.36.36.41.41,0,0,0,.37.42,3.23,3.23,0,0,1,2.33,1.64.43.43,0,0,0,.32.2A.38.38,0,0,0,243.77,212.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.229px 211.3px"
    },
    id: "elhmk4gyc1nje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.51,224.4a35.07,35.07,0,0,0-2.29,3.32c-.18-.07-.36-.14-.54-.23-2.43-1.05-3.12-2.52-3.15-3.82a5.41,5.41,0,0,1,.92-2.92c.87,1.5,3.05,2.69,4.24,3.27C236.19,224.27,236.51,224.4,236.51,224.4Z",
    style: {
      fill: "rgb(46, 53, 58)",
      transformOrigin: "233.52px 224.235px"
    },
    id: "elekutaw1934",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,224l-.35.48a.72.72,0,0,1-.89.24c-1.8-.85-3-1.75-3.42-2.71a.66.66,0,0,1,0-.58,5,5,0,0,1,.39-.7C232.32,222.25,234.5,223.44,235.69,224Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "233.326px 222.758px"
    },
    id: "elq6ubaysar3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.68,227.49c-2.43-1.05-3.12-2.52-3.15-3.82a6.93,6.93,0,0,1,2.41,1.82A3.37,3.37,0,0,1,233.68,227.49Z",
    style: {
      fill: "rgb(222, 87, 83)",
      transformOrigin: "232.105px 225.58px"
    },
    id: "elvn3ribepv2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.84,214.81c.42.08.66.68.54,1.33s-.58,1.11-1,1-.66-.68-.54-1.33S240.42,214.73,240.84,214.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "240.61px 215.978px"
    },
    id: "elm0oin1y3esj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.71,212.89c.42.07.66.67.53,1.32s-.58,1.12-1,1-.66-.68-.53-1.32S232.28,212.81,232.71,212.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.475px 214.055px"
    },
    id: "el4i30zuv3yzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.85,221.38s1.79,1.18,3.26.5c-1.22-2.71-1.05-2.1-1.42-6.71Z",
    style: {
      fill: "rgb(237, 132, 126)",
      transformOrigin: "238.48px 218.631px"
    },
    id: "eluk5heiru24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.76,306s-9.84,3.81-12.09,4.56a28.43,28.43,0,0,1-8.1,1.86,10,10,0,0,1-7.67-2.86c-2.35-2.51-3.08-6.32-3.69-9.88Q206.5,284,203.8,268.27c-.89-5.16-3.14-12.93-3-15.89.35-5.44,3.82-11.87,12.64-15.41,3.43-1.37,6.82-.84,9.71,2.61,1.72,2.07,6.75,7,8,15.76,1,7,2.52,16.07,2.43,23.18C233.5,287.85,237.21,299.64,240.76,306Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.777px 274.356px"
    },
    id: "elc9uv0endcyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.33,249.51c-1,9.11,4,32.07,5,33.45,4.13,13.32,15.47,6.14,17.12,5.53,2.86-1.06,5.77-3.12,8.49-4.5,5.29-2.62,10.28-4.73,15.2-8l-2.77-5.46c-5.38,1.84-20.62,5.77-23.13,6.39-1.09.28-5.33,2.51-5.29-.43-.6-1-1.43-20-3.25-26.71a5.9,5.9,0,0,0-1.06-2.07l-.17-.21a5.82,5.82,0,0,0-10.14,2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.169px 268.137px"
    },
    id: "ela8u1ah1dxjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln3z6o6h128l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.33,249.51c-1,9.11,4,32.07,5,33.45,4.13,13.32,15.47,6.14,17.12,5.53,2.86-1.06,5.77-3.12,8.49-4.5,5.29-2.62,10.28-4.73,15.2-8l-2.77-5.46c-5.38,1.84-20.62,5.77-23.13,6.39-1.09.28-5.33,2.51-5.29-.43-.6-1-1.43-20-3.25-26.71a5.9,5.9,0,0,0-1.06-2.07l-.17-.21a5.82,5.82,0,0,0-10.14,2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "224.169px 268.137px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.33,272.34l-.58,3.12c1.38,3.6,9.31,2.65,9.31,2.65l0-9.22-7,1.63A2.33,2.33,0,0,0,242.33,272.34Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "246.405px 273.557px"
    },
    id: "el6c3qdkco4ux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.08 268.89 251.04 278.13 258.06 278.3 259.67 270.18 251.08 268.89",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "255.355px 273.595px"
    },
    id: "elxk1pinzyeye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92,206.64a2.12,2.12,0,0,1-.91,2.24,3.18,3.18,0,0,1-2,.09l-6.9-1.19c-4-.69-7.92-1.38-11.83-2.32-1.75-.42-4.3-.94-4.41-2.74-.53-8.65,13.6-6.94,16.62-5.89C247.37,200.31,246.77,205.79,246.92,206.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "233.913px 202.521px"
    },
    id: "ellr550f2musb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5",
    className: "animable",
    style: {
      transformOrigin: "127.044px 304.861px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.73,
    y: 364.34,
    width: 9.37,
    height: 39.11,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.415px 383.895px"
    },
    id: "el9yy4xact54c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8v0y3v7xlq7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.73,
    y: 364.34,
    width: 9.37,
    height: 39.11,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "116.415px 383.895px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.07,
    y: 339.56,
    width: 6.68,
    height: 24.97,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.41px 352.045px"
    },
    id: "el573i5p24i7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfw22ocr30x6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119.75 344.19 113.07 346.63 113.07 339.56 119.75 339.56 119.75 344.19",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "116.41px 343.095px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.32,409.27a3.83,3.83,0,1,0,3.83-3.83,3.83,3.83,0,0,0-3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.15px 409.27px"
    },
    id: "el2pyqnjj65u3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.06,409.27a3.84,3.84,0,1,1-3.83-3.83,3.84,3.84,0,0,1,3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "83.22px 409.28px"
    },
    id: "el6r17pq76lrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.24,408a3.83,3.83,0,1,1-3.83-3.83,3.84,3.84,0,0,1,3.83,3.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.41px 408px"
    },
    id: "elhmy8edm5kvm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.88,404.13a1.86,1.86,0,0,0,1.89,1.49l40-.54,37.41.84a1.84,1.84,0,0,0,1.87-1.49,1.85,1.85,0,0,0-1.46-2.19l-20.43-4a34.66,34.66,0,0,0-6.43-.6h-22a34.63,34.63,0,0,0-6.42.6l-23,3.68A1.86,1.86,0,0,0,74.88,404.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.463px 401.781px"
    },
    id: "eleam7nu6uvc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.27,339.46v.09h1.31A9.4,9.4,0,0,1,74.27,339.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "74.925px 339.505px"
    },
    id: "el8zcbgvsxtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.74,263.06a1.21,1.21,0,0,1,0,.19v68.4H66.44V262.54a11.67,11.67,0,0,1,.1-1.56l-.1,0,.58-9.63a11.44,11.44,0,0,1,3.18-7.26l6.13-6.42,3.16-16a5.33,5.33,0,0,1,5.22-4.3H98.85a5.34,5.34,0,0,1,5,3.6l5.92,17.26,11.29,6.95a11.48,11.48,0,0,1,5.34,8.1l1.47,9.82Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "97.155px 274.51px"
    },
    id: "elj172xzr5hbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluojbeqsf9n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.74,263.06a1.21,1.21,0,0,1,0,.19v68.4H74.66V262.54a11.67,11.67,0,0,1,.1-1.56l-.1,0,.58-9.63a11.44,11.44,0,0,1,3.18-7.26l6.13-6.42,3.16-16a5.33,5.33,0,0,1,5.22-4.3h5.92a5.34,5.34,0,0,1,5,3.6l5.92,17.26,11.29,6.95a11.48,11.48,0,0,1,5.34,8.1l1.47,9.82Z",
    style: {
      opacity: 0.1,
      transformOrigin: "101.265px 274.51px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.07,342.87H100.16a121.22,121.22,0,0,0,12.68,4.28v5.33h7.54v-5.33A121.76,121.76,0,0,0,133.07,342.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.615px 347.675px"
    },
    id: "ell2lyfs77z6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85,328.45a397.5,397.5,0,0,0,58.24-2.06,6.31,6.31,0,0,1,7.19,6.38v1a8.28,8.28,0,0,1-7.19,8,397.5,397.5,0,0,1-58.24,2.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "134.566px 335.223px"
    },
    id: "el78ra95t3axw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el08eyfka88lne"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.85,328.45a397.5,397.5,0,0,0,58.24-2.06,6.31,6.31,0,0,1,7.19,6.38v1a8.28,8.28,0,0,1-7.19,8,397.5,397.5,0,0,1-58.24,2.06Z",
    style: {
      opacity: 0.2,
      transformOrigin: "134.566px 335.223px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.76,341.73c11.12,1,22.09,1.78,33.25,2.22a6.68,6.68,0,0,0,6.85-6.71v-1.7a7,7,0,0,0-6.85-7c-11.16-.45-22.13-1.18-33.25-2.23a6,6,0,0,0-6.82,6v1.7A7.85,7.85,0,0,0,72.76,341.73Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "89.3999px 335.103px"
    },
    id: "elej5kkrr3jlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.04 385.88 166.97 402.69 175.36 402.52 177.09 386.66 167.04 385.88",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "172.03px 394.285px"
    },
    id: "elna8ftnkp9tr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,402.34a.19.19,0,0,1-.15-.16.18.18,0,0,1,.09-.2c.13-.07,3-1.66,4.33-1.27a1,1,0,0,1,.6.46.72.72,0,0,1,0,.83,3.48,3.48,0,0,1-2.4.6A14.8,14.8,0,0,1,176.83,402.34Zm.63-.25c1.51.2,3.55.21,3.94-.31,0-.07.1-.18,0-.42a.51.51,0,0,0-.37-.28,1.57,1.57,0,0,0-.37-.05A8.88,8.88,0,0,0,177.46,402.09Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "179.253px 401.636px"
    },
    id: "elk9w8dg3e66i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.73,402.33a.18.18,0,0,1-.08-.18c0-.1.25-2.29,1.29-3.13a1.44,1.44,0,0,1,1.08-.31c.53.06.69.33.7.55.17.91-1.8,2.65-2.78,3.07h-.08A.19.19,0,0,1,176.73,402.33Zm2.15-3.26a1,1,0,0,0-.66.23,4.54,4.54,0,0,0-1.11,2.48c1-.58,2.31-1.95,2.26-2.5,0,0,0-.19-.38-.22Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "178.189px 400.52px"
    },
    id: "elclgfwxy29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,401.19l-8.86-.1a.73.73,0,0,0-.71.55l-1.68,7.19a1.19,1.19,0,0,0,.88,1.43l.24,0c3.2,0,6-.17,10-.12,4.69.06,3.49.61,9,.75,3.32.08,4-3.69,2.57-3.9-6.45-.88-7.09-2.84-9.56-5.17A2.84,2.84,0,0,0,176,401.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "176.433px 405.991px"
    },
    id: "elbz4qbhwju0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el857nfslg5f3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "167.74 395.65 176.64 395.05 177.18 384.14 167.09 383.96 167.74 395.65",
    style: {
      opacity: 0.1,
      transformOrigin: "172.135px 389.805px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1gfbwumlvx3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.47,322c0,.15.07.3.1.45a43.57,43.57,0,0,0-.95-6.15c-2.86-11.13-32.66-13-44.85-13.28l-14.65,1.61s-1.37,11.73,2.12,19.16S164.47,322,164.47,322Z",
    style: {
      opacity: 0.4,
      transformOrigin: "134.213px 314.852px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "147.13 388.9 147.89 405.96 156.15 405.66 157.13 387.6 147.13 388.9",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "152.13px 396.78px"
    },
    id: "el89jebtjlxtx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46,403.35a.2.2,0,0,1-.17-.15.18.18,0,0,1,.08-.2c.11-.09,2.8-1.94,4.18-1.68a1,1,0,0,1,.64.39.74.74,0,0,1,.09.84,3.5,3.5,0,0,1-2.33.82A14.79,14.79,0,0,1,157.46,403.35Zm.6-.31c1.52,0,3.56-.13,3.89-.69.05-.07.09-.19-.08-.42a.52.52,0,0,0-.4-.23,1.14,1.14,0,0,0-.37,0A9,9,0,0,0,158.06,403Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "159.827px 402.354px"
    },
    id: "elblzs9qe0ske",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.36,403.35a.19.19,0,0,1-.1-.17c0-.1,0-2.3,1-3.24a1.49,1.49,0,0,1,1-.42c.53,0,.72.26.76.48.25.9-1.54,2.82-2.47,3.33a.11.11,0,0,1-.08,0A.2.2,0,0,1,157.36,403.35Zm1.83-3.45a1,1,0,0,0-.65.3,4.53,4.53,0,0,0-.86,2.57c.95-.68,2.11-2.16,2-2.71,0,0-.05-.18-.4-.18l-.1,0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "158.652px 401.436px"
    },
    id: "elsqj64taoy9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,402.29l-8.83.75a.73.73,0,0,0-.65.62l-1,7.32a1.2,1.2,0,0,0,1,1.34h.25c3.18-.32,6-.74,10-1.07,4.67-.4,3.53.26,9-.13,3.31-.24,3.6-4.06,2.18-4.13-6.5-.25-7.34-2.14-10-4.23A2.87,2.87,0,0,0,156.54,402.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "157.674px 407.295px"
    },
    id: "elfmazbqqf5zt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpzcfn4m7yp9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "156.55 397.85 157.02 389.24 147.18 389.46 147.57 398.48 156.55 397.85",
    style: {
      opacity: 0.1,
      transformOrigin: "152.1px 393.86px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.26,302s52-4,55.59,10.05-4.38,80.15-4.38,80.15l-12.86,1.08s-1.69-39-1.92-71.29c0,0-54.74,9.22-58.23,1.79s-2.12-19.16-2.12-19.16Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "143.427px 347.377px"
    },
    id: "elsi32vqca6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26,302s52-4,55.59,10.05-4.38,80.15-4.38,80.15l-12.86,1.08s-1.69-39-1.92-71.29c0,0-54.74,9.22-58.23,1.79s-2.12-19.16-2.12-19.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.427px 347.377px"
    },
    id: "elmtsqgu0hoc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmuwxgmtauc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.26,302s52-4,55.59,10.05-4.38,80.15-4.38,80.15l-12.86,1.08s-1.69-39-1.92-71.29c0,0-54.74,9.22-58.23,1.79s-2.12-19.16-2.12-19.16Z",
    style: {
      opacity: 0.1,
      transformOrigin: "143.427px 347.377px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,304.05s52.41-2,53.13,12.43c.56,11.31-9,78.47-9,78.47l-12,.93s-2.2-40.36-.7-67.91c0,0-45.23,5.19-53.2-1.18C84.8,320.72,90.71,304,90.71,304Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "127.898px 349.918px"
    },
    id: "elwqahq1u0c5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-5",
    className: "animable",
    style: {
      transformOrigin: "129.623px 251.046px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.19,293.31v-.2a5.61,5.61,0,0,1,4.61-4.56l5.58-.91s9.29,4.59,7.17,5.61H170.29Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "172.027px 290.475px"
    },
    id: "eloqrwun2d85c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.73,288.07l-7.54,5.24L141.26,279l-9.6-9.63s-18.18-27.88-9.22-29.52c4.09-.75,18.4,17.66,27.54,32.73l0,0C160.9,281.36,170.73,288.07,170.73,288.07Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "145.344px 266.569px"
    },
    id: "elci74owuzheh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljizeo3d1x3r"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "145.344px 266.569px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.73,288.07l-7.54,5.24L141.26,279l-9.6-9.63s-18.18-27.88-9.22-29.52c4.09-.75,18.4,17.66,27.54,32.73l0,0C160.9,281.36,170.73,288.07,170.73,288.07Z",
    id: "el1iw17boi7f3",
    className: "animable",
    style: {
      transformOrigin: "145.344px 266.569px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M131.66,303h0a74.36,74.36,0,0,1-23.49,2.36l-17-1c-.4-3.5-3-11.17-6.62-31-4.48-31.62.83-33.27,3.55-33.75h.09c2.52-.42,5.68-.88,8.79-1.11a165.66,165.66,0,0,1,17.82-.54,50.35,50.35,0,0,1,5.9.76,7.46,7.46,0,0,1,5.93,4.73C129.41,251.49,130.37,270.56,131.66,303Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "107.239px 271.702px"
    },
    id: "elgmzaxtlojh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldxtk5fjnyos"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.66,303h0a74.36,74.36,0,0,1-23.49,2.36l-17-1c-.4-3.5-3-11.17-6.62-31-4.48-31.62.83-33.27,3.55-33.75h.09c2.52-.42,5.68-.88,8.79-1.11a165.66,165.66,0,0,1,17.82-.54,50.35,50.35,0,0,1,5.9.76,7.46,7.46,0,0,1,5.93,4.73C129.41,251.49,130.37,270.56,131.66,303Z",
    style: {
      opacity: 0.4,
      transformOrigin: "107.239px 271.702px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,243c-8.82.75-12.19-4.45-12.19-4.45,3.76-4,1.95-14.4.46-20.1l4.88,3.81,6.66,5.19a23.68,23.68,0,0,0-.33,2.65,10.13,10.13,0,0,0,0,1.91v.13c.3,2.67,1.78,4.88,6,5.73C114,237.88,116.07,242.34,108.56,243Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "105.321px 230.762px"
    },
    id: "el7g81huq28bm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldvo2tl4t6fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.37,227.46a23.68,23.68,0,0,0-.33,2.65,10.13,10.13,0,0,0,0,1.91v.13c-2.43-.43-5.7-2.89-6.14-5.36a11.89,11.89,0,0,1-.17-2.46Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "105.046px 228.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.54,238l2.69-1.09A26.89,26.89,0,0,0,108,243a10.4,10.4,0,0,0-3.68,4.8C94.79,244.92,94.54,238,94.54,238Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.27px 242.355px"
    },
    id: "elbjngz1wdnkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,237.39l-2.55-.45s-.87,5.31-3.45,6.13c4.61,1.63,5.43,3.85,5.43,3.85C119.89,244.61,114,237.39,114,237.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "112.228px 241.93px"
    },
    id: "elg1ki3o36x48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,201.6c1.33,1.56,1.73,5.36,3,6.91a29,29,0,0,0,1.75-4.85,2.37,2.37,0,0,0-.75-2.28C115.45,200.67,113.44,201.2,112.34,201.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.742px 204.771px"
    },
    id: "elz3xuwohc5q9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,207.15A10.27,10.27,0,0,1,108,199.57c8.1,1.74,11.53,12.85,11.32,20a10.15,10.15,0,0,1-16,8.16c-4.7-3.23-5.53-7.73-7.58-15.25A10.25,10.25,0,0,1,95.58,207.15Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "107.316px 214.432px"
    },
    id: "elzyrt3h9xhie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48,220.12a37.29,37.29,0,0,0-7.93,0,4.53,4.53,0,0,0,5.07,3.17,2.92,2.92,0,0,0,2.86-2.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.515px 221.629px"
    },
    id: "elc5ozup9e59e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.19,221.84a5,5,0,0,1,3.28.74,3.11,3.11,0,0,1-1.84.7,4.93,4.93,0,0,1-3.28-.73A3,3,0,0,1,111.19,221.84Z",
    style: {
      fill: "rgb(232, 63, 63)",
      transformOrigin: "111.91px 222.562px"
    },
    id: "elw106mzhtxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,220.09a1.32,1.32,0,0,1-.88,1,27.89,27.89,0,0,1-5.17-.15,1.59,1.59,0,0,1-1.34-.87A43.42,43.42,0,0,1,115.21,220.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "111.515px 220.535px"
    },
    id: "eln28tlyu231",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk441f0rg6kh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.85,217.89a3.6,3.6,0,0,0,2.83-1.06,23.06,23.06,0,0,1-4.09-4.78Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "114.635px 214.975px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.9,202.71a15.66,15.66,0,0,0-1.05-1.71,3,3,0,0,0-3.08-.72,4.84,4.84,0,0,0-2.54,2.09,16,16,0,0,0-1.63,3.46,3.39,3.39,0,0,1-1,2.83l0,0a3.34,3.34,0,0,1-2.85.75c-.38,1.14,2.08,4.45,2.55,4.88a4,4,0,0,0,1.55.9,3.33,3.33,0,0,1-1.69.31l-.54-.06c-2-.34-9.71-5.17-5.35-13.18A11.47,11.47,0,0,1,111,198.2C116.29,201.63,111.29,203.27,110.9,202.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.684px 206.056px"
    },
    id: "el4wj9no9szb8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.62,216.86c0,2.37.27,7.56-.17,10.63-2.7-2.16-5.3-7-6.54-10.27a14.14,14.14,0,0,1,.39-11.35,11.3,11.3,0,0,1,2.93-3.59,10.29,10.29,0,0,1,6.45-2.39c0,3,0,5.89-.12,8.79a3.34,3.34,0,0,1-2.85.75c-.38,1.14.66,3.36,1.23,4.43a5.25,5.25,0,0,0,1.13,1.49c0,.4-.08.81-.13,1.21-.12.92-.24,1.85-.39,2.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "96.2936px 213.69px"
    },
    id: "el0uopsff953id",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.78,214.28c1.93-.32,4,2.07,4.87,3.82.93,2,.31,3.81-1.74,3.36a7.34,7.34,0,0,1-4-2.81C93.61,216.92,93.86,214.6,95.78,214.28Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "97.5863px 217.89px"
    },
    id: "el08ru94icpyxx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,212c.41-.06.86.44,1,1s-.11,1.12-.52,1.19-.79-.38-1-1S107.71,212.05,108.12,212Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.346px 213.096px"
    },
    id: "ela8ixqw80i6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06,210.4c.41-.07.84.37,1,1s-.09,1.18-.5,1.25-.85-.38-1-1S114.65,210.47,115.06,210.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.312px 211.525px"
    },
    id: "el9pywkiu2hrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,208a.41.41,0,0,0,.34.08,3.14,3.14,0,0,1,2.73.34.36.36,0,0,0,.51-.05h0a.39.39,0,0,0-.06-.52h0a3.81,3.81,0,0,0-3.4-.47.38.38,0,0,0-.25.46A.52.52,0,0,0,113.51,208Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.265px 207.839px"
    },
    id: "elsj4b4ioeopf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,211.08a.41.41,0,0,0,.32-.15,3.19,3.19,0,0,1,2.36-1.41.35.35,0,0,0,.37-.35v0a.38.38,0,0,0-.37-.37h0a3.87,3.87,0,0,0-3,1.72.38.38,0,0,0,.1.52A.6.6,0,0,0,106,211.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.334px 209.94px"
    },
    id: "elbmr52sg76v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.52,259.8l1-2.08c1.3-2.73,6.71-13.6,9.35-14.75l1-.62L107.5,248c-.63.54-7.56,18.44-9.22,22.19a13.21,13.21,0,0,0-.65,1.76c-1.13,4.1-8.11,10.39-12.78-1.42-1.16-2.48-2.23-4.93-3.19-7.4-.49-1.29-.93-2.5-1.38-3.78l-.46-1.3c-2.15-6.17-2.52-13.24,3.37-16.87l4-1.34Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "92.9406px 258.589px"
    },
    id: "elsxva72gohw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk2xscqbf3a"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "92.9406px 258.589px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.52,259.8l1-2.08c1.3-2.73,6.71-13.6,9.35-14.75l1-.62L107.5,248c-.63.54-7.56,18.44-9.22,22.19a13.21,13.21,0,0,0-.65,1.76c-1.13,4.1-8.11,10.39-12.78-1.42-1.16-2.48-2.23-4.93-3.19-7.4-.49-1.29-.93-2.5-1.38-3.78l-.46-1.3c-2.15-6.17-2.52-13.24,3.37-16.87l4-1.34Z",
    id: "eldinmdx04jv4",
    className: "animable",
    style: {
      transformOrigin: "92.9406px 258.589px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,238.32a3.42,3.42,0,0,0,.19.78,6.1,6.1,0,0,0,.45,1.09,5.61,5.61,0,0,0,1,1.2s.25.21.26.23a5.83,5.83,0,0,0,.74.57,4.53,4.53,0,0,0,1.64.75.39.39,0,0,1,.26.21c.07.14.16.28.24.41s.13.24.18.36a.89.89,0,0,0,.36.43,3,3,0,0,0,1,.37,10.75,10.75,0,0,0,2.83.2,14.33,14.33,0,0,0,1.47-.12,11.92,11.92,0,0,0,1.55-.34,4.43,4.43,0,0,0,1.16-.5.79.79,0,0,0,.35-.37,2.15,2.15,0,0,1,.1-.27l.31-.75c.15-.38.28-.78.4-1.17a11.22,11.22,0,0,0,.33-1.17c.08-.4.17-.8.23-1.21.1-.68.18-1.37.25-2.07,0-.32,0-.7.05-1a3,3,0,0,0-.09-.79,1.14,1.14,0,0,0-.28-.47,3.69,3.69,0,0,0-1.29-.84,6.26,6.26,0,0,0-1.41-.38c-.2,0-.4-.08-.6-.1a14.9,14.9,0,0,0-6.35.48,8.75,8.75,0,0,0-1.21.44,5.08,5.08,0,0,0-1,.62,2.17,2.17,0,0,0-.54.66,1,1,0,0,0-.1.31c0,.12,0,.13-.15.11a1.87,1.87,0,0,0-1.83.57,2.06,2.06,0,0,0-.39.73A2.92,2.92,0,0,0,113.43,238.32Zm5.24-1.62a6,6,0,0,1-1.25-.36.72.72,0,0,1-.27-.15,1.76,1.76,0,0,1,.53-.63,4.34,4.34,0,0,1,.46-.28,5.19,5.19,0,0,1,.89-.36,11.63,11.63,0,0,1,1.44-.35c.47-.08.92-.13,1.4-.17s.79,0,1.23,0a12.83,12.83,0,0,1,1.65.1,8.31,8.31,0,0,1,1.64.38,2.81,2.81,0,0,1,1.19.75s0,0,0,0l-.12.09a2.33,2.33,0,0,1-.34.2,5.82,5.82,0,0,1-1.41.52l-.33.09-.19,0a10.55,10.55,0,0,1-1.1.19,9.88,9.88,0,0,1-1.08.11l-.84.06h-.06s0,0,0,0h-1.26c-.33,0-.66,0-1,0A10.45,10.45,0,0,1,118.67,236.7ZM115.14,238a.78.78,0,0,1,.64-.63l.23,0c.1.54.23,1.05.35,1.56.15.68.36,1.33.57,2a3.39,3.39,0,0,0,.42.92l-.39-.3a5.54,5.54,0,0,1-1-1.07,5.21,5.21,0,0,1-.74-1.3A1.93,1.93,0,0,1,115.14,238Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "121.102px 239.082px"
    },
    id: "el075q1uwqu2ro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljw9mz1jrxtb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.43,238.32a3.42,3.42,0,0,0,.19.78,6.1,6.1,0,0,0,.45,1.09,5.61,5.61,0,0,0,1,1.2s.25.21.26.23a5.83,5.83,0,0,0,.74.57,4.53,4.53,0,0,0,1.64.75.39.39,0,0,1,.26.21c.07.14.16.28.24.41s.13.24.18.36a.89.89,0,0,0,.36.43,3,3,0,0,0,1,.37,10.75,10.75,0,0,0,2.83.2,14.33,14.33,0,0,0,1.47-.12,11.92,11.92,0,0,0,1.55-.34,4.43,4.43,0,0,0,1.16-.5.79.79,0,0,0,.35-.37,2.15,2.15,0,0,1,.1-.27l.31-.75c.15-.38.28-.78.4-1.17a11.22,11.22,0,0,0,.33-1.17c.08-.4.17-.8.23-1.21.1-.68.18-1.37.25-2.07,0-.32,0-.7.05-1a3,3,0,0,0-.09-.79,1.14,1.14,0,0,0-.28-.47,3.69,3.69,0,0,0-1.29-.84,6.26,6.26,0,0,0-1.41-.38c-.2,0-.4-.08-.6-.1a14.9,14.9,0,0,0-6.35.48,8.75,8.75,0,0,0-1.21.44,5.08,5.08,0,0,0-1,.62,2.17,2.17,0,0,0-.54.66,1,1,0,0,0-.1.31c0,.12,0,.13-.15.11a1.87,1.87,0,0,0-1.83.57,2.06,2.06,0,0,0-.39.73A2.92,2.92,0,0,0,113.43,238.32Zm5.24-1.62a6,6,0,0,1-1.25-.36.72.72,0,0,1-.27-.15,1.76,1.76,0,0,1,.53-.63,4.34,4.34,0,0,1,.46-.28,5.19,5.19,0,0,1,.89-.36,11.63,11.63,0,0,1,1.44-.35c.47-.08.92-.13,1.4-.17s.79,0,1.23,0a12.83,12.83,0,0,1,1.65.1,8.31,8.31,0,0,1,1.64.38,2.81,2.81,0,0,1,1.19.75s0,0,0,0l-.12.09a2.33,2.33,0,0,1-.34.2,5.82,5.82,0,0,1-1.41.52l-.33.09-.19,0a10.55,10.55,0,0,1-1.1.19,9.88,9.88,0,0,1-1.08.11l-.84.06h-.06s0,0,0,0h-1.26c-.33,0-.66,0-1,0A10.45,10.45,0,0,1,118.67,236.7ZM115.14,238a.78.78,0,0,1,.64-.63l.23,0c.1.54.23,1.05.35,1.56.15.68.36,1.33.57,2a3.39,3.39,0,0,0,.42.92l-.39-.3a5.54,5.54,0,0,1-1-1.07,5.21,5.21,0,0,1-.74-1.3A1.93,1.93,0,0,1,115.14,238Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "121.102px 239.082px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4hsntfkpzme"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.14,236.19a1.67,1.67,0,0,1,.53-.63,3.64,3.64,0,0,1,.47-.28,4.79,4.79,0,0,1,.88-.36,11.63,11.63,0,0,1,1.44-.35c.47-.08.92-.13,1.4-.17s.79,0,1.23,0a13.1,13.1,0,0,1,1.66.11,7.69,7.69,0,0,1,1.63.37,2.81,2.81,0,0,1,1.19.75l0,0-.12.09a3,3,0,0,1-.34.2,6.68,6.68,0,0,1-1.41.53l-.34.08-.19,0c-.36.08-.73.15-1.1.2a9.63,9.63,0,0,1-1.08.1l-.84.06h-.24c-.37,0-.74,0-1.11,0l-1,0c-.38,0-.76-.11-1.13-.18a5.2,5.2,0,0,1-1.24-.36A.69.69,0,0,1,117.14,236.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "122.355px 235.636px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.16,236.19a1.56,1.56,0,0,1,.53-.63,4.34,4.34,0,0,1,.46-.28,6.2,6.2,0,0,1,.89-.37,14.14,14.14,0,0,1,1.43-.34c.48-.08.93-.13,1.41-.17s.79,0,1.23,0a13.09,13.09,0,0,1,1.66.1,8.38,8.38,0,0,1,1.63.38,2.87,2.87,0,0,1,1.19.75l0,0a.4.4,0,0,1-.12.1,2.23,2.23,0,0,1-.33.2,6.56,6.56,0,0,1-1.42.53l-.34.08-.18,0c-.37.08-.73.14-1.1.19s-.72.09-1.08.11l-.84.06h-1.35l-1,0c-.38,0-.76-.11-1.13-.18a6,6,0,0,1-1.25-.36A.72.72,0,0,1,117.16,236.19Z",
    style: {
      fill: "none",
      transformOrigin: "122.375px 235.641px"
    },
    id: "el8za5aa8j5rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.16,236.19a1.56,1.56,0,0,1,.53-.63,4.34,4.34,0,0,1,.46-.28,6.2,6.2,0,0,1,.89-.37,14.14,14.14,0,0,1,1.43-.34c.48-.08.93-.13,1.41-.17s.79,0,1.23,0a13.09,13.09,0,0,1,1.66.1,8.38,8.38,0,0,1,1.63.38,2.87,2.87,0,0,1,1.19.75l0,0a.4.4,0,0,1-.12.1,2.23,2.23,0,0,1-.33.2,6.56,6.56,0,0,1-1.42.53l-.34.08-.18,0c-.37.08-.73.14-1.1.19s-.72.09-1.08.11l-.84.06h-1.35l-1,0c-.38,0-.76-.11-1.13-.18a6,6,0,0,1-1.25-.36A.72.72,0,0,1,117.16,236.19Z",
    style: {
      fill: "none",
      transformOrigin: "122.375px 235.641px"
    },
    id: "elmufm9yohd5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15,236.19a.72.72,0,0,0,.27.15,6,6,0,0,0,1.25.36,10.45,10.45,0,0,0,1.12.18c.33,0,.66,0,1,0H122s0,0,0,0h.06l.84-.06a9.88,9.88,0,0,0,1.08-.11,10.55,10.55,0,0,0,1.1-.19l.19,0,.33-.09a5.82,5.82,0,0,0,1.41-.52,2.33,2.33,0,0,0,.34-.2l.12-.09s0,0,0,0a2.81,2.81,0,0,0-1.19-.75,8.31,8.31,0,0,0-1.64-.38,12.83,12.83,0,0,0-1.65-.1c-.44,0-.79,0-1.23,0s-.93.09-1.4.17a11.63,11.63,0,0,0-1.44.35,5.19,5.19,0,0,0-.89.36,4.34,4.34,0,0,0-.46.28A1.76,1.76,0,0,0,117.15,236.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "122.31px 235.635px"
    },
    id: "el8n57j8zncgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkoo545uypro"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.11,235.26a3.19,3.19,0,0,1,.32-.32,8.13,8.13,0,0,1,3.75-1.31,11.29,11.29,0,0,1,2.25-.12,8.74,8.74,0,0,1,3.75.87,2.53,2.53,0,0,1,.36.29.68.68,0,0,1,.07.9l-.14.11h0c-1.15-1.13-4.18-1.17-5.17-1.16s-4,.49-5,1.74h0l-.14-.1A.66.66,0,0,1,117.11,235.26Z",
    style: {
      opacity: 0.3,
      transformOrigin: "122.352px 234.879px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.59,239.23l.66,3.21-2,2.43A14.18,14.18,0,0,1,107.5,248a3.3,3.3,0,0,1-3.32-1.79l-.32-.62a4,4,0,0,1-.32-.87c-.39-1.66.17-2.59,1.56-3.56l4.83-4.25a57.58,57.58,0,0,1,5.87-.75C116.4,236.11,115.71,238.64,115.59,239.23Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "109.834px 242.09px"
    },
    id: "el0w3n1yp4me7o",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-5",
    className: "animable",
    style: {
      transformOrigin: "320.055px 214.169px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--speech-bubbles--inject-120--inject-5",
    className: "animable",
    style: {
      transformOrigin: "320.055px 214.169px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.57,192.3l3.51,33.06a3.18,3.18,0,0,1,0,.62,3.78,3.78,0,0,1-3.93,3.63l-7.53,0c1.63,4.69,8.51,11,8.51,11a32.46,32.46,0,0,1-19-11.06l-53.91-.33a5,5,0,0,1-4.82-4.31L278,191.82a3.33,3.33,0,0,1,0-.63,3.78,3.78,0,0,1,3.93-3.63l71.9.43A5,5,0,0,1,358.57,192.3Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "320.04px 214.083px"
    },
    id: "eldfd3aygfqy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,241.29l-1.59-.22A33.35,33.35,0,0,1,340,230l-53.68-.33a5.45,5.45,0,0,1-5.31-4.74l-3.53-33.07a4.06,4.06,0,0,1,0-.7,4.31,4.31,0,0,1,4.45-4.11l71.88.43a5.45,5.45,0,0,1,5.3,4.75h0l3.52,33.05a4.06,4.06,0,0,1,0,.7,4.28,4.28,0,0,1-4.45,4.11l-6.77,0c1.94,4.43,8.05,10.07,8.11,10.13Zm-79-53.23a3.26,3.26,0,0,0-2.24.87,3.32,3.32,0,0,0-1.05,2.28,2.45,2.45,0,0,0,0,.54L282,224.82a4.45,4.45,0,0,0,4.33,3.86l54.14.33.15.18a32.2,32.2,0,0,0,17,10.54c-2.09-2.08-6.16-6.44-7.39-10l-.23-.67,8.23,0a3.3,3.3,0,0,0,3.43-3.15,3.25,3.25,0,0,0,0-.54l-3.52-33.06a4.46,4.46,0,0,0-4.33-3.87l-71.88-.43Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "320.055px 214.169px"
    },
    id: "ell706v9u68ll",
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 311.86,
    y: 196.38,
    width: 40.04,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "331.88px 196.88px"
    },
    id: "elb7whwfdiex8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.48,
    y: 196.38,
    width: 14.47,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "298.715px 196.88px"
    },
    id: "el39rpwpvuac9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.04,
    y: 205.03,
    width: 17.76,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "344.92px 205.53px"
    },
    id: "el2kiwwlfnu14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.46,
    y: 205.03,
    width: 23.25,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "318.085px 205.53px"
    },
    id: "elsx8frb6h76h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.87,
    y: 205.03,
    width: 14.15,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "293.945px 205.53px"
    },
    id: "el9qii9zhrvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.39,
    y: 213.68,
    width: 27.4,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "341.09px 214.18px"
    },
    id: "elmdj1a6c8li8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.66,
    y: 213.68,
    width: 12.48,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.9px 214.18px"
    },
    id: "elivwrpselra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.72,
    y: 213.68,
    width: 10.95,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "304.195px 214.18px"
    },
    id: "eltc2ongsm6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.87,
    y: 213.68,
    width: 7.9,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "291.82px 214.18px"
    },
    id: "elzedy56e81d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.67,
    y: 222.33,
    width: 11.72,
    height: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.53px 222.83px"
    },
    id: "eloqmcy72seu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-5",
    className: "animable",
    style: {
      transformOrigin: "294.51px 176.639px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-speech-bubbles-inject-120--inject-5",
    className: "animable",
    style: {
      transformOrigin: "294.51px 176.639px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.8,150.45l71.89-.43a3.79,3.79,0,0,1,3.93,3.64,3.26,3.26,0,0,1,0,.62l-3.52,33.06a5,5,0,0,1-4.82,4.31l-53.91.32A32.51,32.51,0,0,1,255.39,203s6.89-6.32,8.51-11l-7.53.05a3.79,3.79,0,0,1-3.93-3.64,3.22,3.22,0,0,1,0-.62l3.51-33A5,5,0,0,1,260.8,150.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.53px 176.509px"
    },
    id: "elrms1eq8neo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.87,203.75l1.18-1.08c.07-.06,6.18-5.69,8.11-10.13l-6.78,0a4.3,4.3,0,0,1-4.44-4.12,4.1,4.1,0,0,1,0-.7l3.52-33a5.46,5.46,0,0,1,5.29-4.76h0l71.9-.43a4.32,4.32,0,0,1,4.43,4.12,4.1,4.1,0,0,1,0,.7l-3.52,33a5.47,5.47,0,0,1-5.3,4.76l-53.69.32a33.3,33.3,0,0,1-19.12,11.06Zm10.73-12.22-.23.67c-1.23,3.55-5.29,7.91-7.38,10a32.18,32.18,0,0,0,17-10.54l.15-.18,54.15-.32a4.47,4.47,0,0,0,4.33-3.88l3.52-33.05a3.31,3.31,0,0,0-3.39-3.7L260.8,151a4.46,4.46,0,0,0-4.32,3.88l-3.51,33a3.44,3.44,0,0,0,0,.55,3.31,3.31,0,0,0,3.41,3.16Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "294.51px 176.639px"
    },
    id: "el7i4oxiwg40s",
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 270.98,
    y: 157.18,
    width: 32.42,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "287.19px 157.68px"
    },
    id: "elvrtqkqqd7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.97,
    y: 157.18,
    width: 19.57,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "320.755px 157.68px"
    },
    id: "ellax9hjvzwff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.47,
    y: 165.83,
    width: 17.76,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "270.35px 166.33px"
    },
    id: "elcwrvt54l7bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.56,
    y: 165.83,
    width: 42.84,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "306.98px 166.33px"
    },
    id: "elyyu0pp9qlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.47,
    y: 174.48,
    width: 45.13,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "283.035px 174.98px"
    },
    id: "eld3bxr9usw1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.65,
    y: 174.48,
    width: 14.75,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "320.025px 174.98px"
    },
    id: "elygm0i065ml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.75,
    y: 183.13,
    width: 11.72,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "265.61px 183.63px"
    },
    id: "ele2lmo76cckt",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-5",
    className: "animable",
    style: {
      transformOrigin: "167.51px 187.554px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik-speech-bubbles-inject-120--inject-5",
    className: "animable",
    style: {
      transformOrigin: "167.51px 187.554px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.79,161.48l71.89-.43a3.79,3.79,0,0,1,3.93,3.64,4.33,4.33,0,0,1,0,.62l-3.53,33.05a5,5,0,0,1-4.81,4.31l-53.92.33a32.46,32.46,0,0,1-19,11.06s6.89-6.31,8.51-11l-7.52,0a3.77,3.77,0,0,1-3.93-3.63,4.24,4.24,0,0,1,0-.62l3.52-33A5,5,0,0,1,133.79,161.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.51px 187.554px"
    },
    id: "elzdt4n9h9u3d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 168.34,
    y: 168.55,
    width: 32.42,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "184.55px 169.05px"
    },
    id: "el2qruotvacpw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 168.55,
    width: 19.57,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "150.995px 169.05px"
    },
    id: "eluh46q2e004d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 177.2,
    width: 17.76,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "191.88px 177.7px"
    },
    id: "elwte4p9mguac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 177.2,
    width: 42.84,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "155.25px 177.7px"
    },
    id: "el5bzd8peq7ll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.63,
    y: 185.85,
    width: 45.13,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "178.195px 186.35px"
    },
    id: "el4nbxz982skb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 185.85,
    width: 14.75,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "141.205px 186.35px"
    },
    id: "elhngxe1mhzhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.83,
    y: 194.5,
    width: 10.92,
    height: 1,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "139.29px 195px"
    },
    id: "elwrdsjnb8edr",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5",
    className: "animable",
    style: {
      transformOrigin: "248.869px 342.25px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el70u6wrbtnt9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.03,
    y: 278.34,
    width: 11.2,
    height: 14.98,
    rx: 2.11,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "272.63px 285.83px",
      transform: "rotate(-180.573deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,287.77l0-2.82a4.19,4.19,0,0,1,4.15-4.22h.94l.1,11.19h-.94A4.18,4.18,0,0,1,263.71,287.77Zm1.85-2.84,0,2.82a2.3,2.3,0,0,0,1.38,2.09l-.06-7A2.33,2.33,0,0,0,265.56,284.93Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "266.305px 286.325px"
    },
    id: "el3o00i1gg812",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb6jqalilclp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "271.007px 285.83px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elofiu0n5ocz"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.03,
    y: 278.34,
    width: 11.2,
    height: 14.98,
    rx: 2.11,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.63px 285.83px",
      transform: "rotate(-180.573deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,287.77l0-2.82a4.19,4.19,0,0,1,4.15-4.22h.94l.1,11.19h-.94A4.18,4.18,0,0,1,263.71,287.77Zm1.85-2.84,0,2.82a2.3,2.3,0,0,0,1.38,2.09l-.06-7A2.33,2.33,0,0,0,265.56,284.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "266.305px 286.325px"
    },
    id: "elkjlxsn81z5k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M353.6,293.11l-21,0a.82.82,0,0,1-.82-.82h0a.82.82,0,0,1,.82-.82h21a.83.83,0,0,1,.82.83h0A.82.82,0,0,1,353.6,293.11Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "343.1px 292.29px"
    },
    id: "ela6qkd4v82a9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqqowvew00t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.6,293.11l-21,0a.82.82,0,0,1-.82-.82h0a.82.82,0,0,1,.82-.82h21a.83.83,0,0,1,.82.83h0A.82.82,0,0,1,353.6,293.11Z",
    style: {
      opacity: 0.4,
      transformOrigin: "343.1px 292.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.46,293.1l-43.69.07a.81.81,0,0,1-.81-.82h0a.82.82,0,0,1,.82-.82l43.69-.07a.81.81,0,0,1,.81.82h0A.82.82,0,0,1,332.46,293.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.62px 292.315px"
    },
    id: "el18ymx663vqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,291.45l-40.25.18a2.9,2.9,0,0,1-2.82-2.63l-1.65-20.64a2.36,2.36,0,0,1,2.4-2.6l40.25-.18a2.9,2.9,0,0,1,2.82,2.63l1.65,20.64A2.36,2.36,0,0,1,331.28,291.45Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "310.12px 278.605px"
    },
    id: "elb4x00ygxdnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell8gazhftd1n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.28,291.45l-40.25.18a2.9,2.9,0,0,1-2.82-2.63l-1.65-20.64a2.36,2.36,0,0,1,2.4-2.6l40.25-.18a2.9,2.9,0,0,1,2.82,2.63l1.65,20.64A2.36,2.36,0,0,1,331.28,291.45Z",
    style: {
      opacity: 0.4,
      transformOrigin: "310.12px 278.605px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.08,291.35l-40.25.18A2.9,2.9,0,0,1,287,288.9l-1.65-20.64a2.36,2.36,0,0,1,2.4-2.6l40.25-.18a2.9,2.9,0,0,1,2.82,2.63l1.66,20.64A2.37,2.37,0,0,1,330.08,291.35Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "308.914px 278.505px"
    },
    id: "elk4bn8d10r9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8634wh2mx2h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.08,291.35l-40.25.18A2.9,2.9,0,0,1,287,288.9l-1.65-20.64a2.36,2.36,0,0,1,2.4-2.6l40.25-.18a2.9,2.9,0,0,1,2.82,2.63l1.66,20.64A2.37,2.37,0,0,1,330.08,291.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "308.914px 278.505px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.14,279.19a4.59,4.59,0,0,0,4.39,4.21,3.71,3.71,0,0,0,3.84-4,4.58,4.58,0,0,0-4.39-4.2A3.71,3.71,0,0,0,303.14,279.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "307.255px 279.3px"
    },
    id: "eldzi35g4p6jg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.53,282.35l.41.74a2.73,2.73,0,0,1,.35,1.33v4.2c0,2.56,2.8,4.66,6.25,4.66h.91a6.62,6.62,0,0,0,5.66-2.71,2,2,0,0,0,.79-.35l2.43-1.81a1.26,1.26,0,0,0,.57-1v-2.27c0-.78-.87-1.42-1.92-1.42H381.7c-.07-.15.07-.39.26-.63L382,283a6,6,0,0,1,.66-.64l.05,0s-.11-.53-1.39-.26c-.37.08-.72.17-1,.26l-.14,0h0l-.1,0a610.48,610.48,0,0,0-6.4-.08c.08,0-.07,0,0,0a5.35,5.35,0,0,0-3.24.08H370c-.32-.09-.68-.18-1.05-.26C367.64,281.82,367.53,282.35,367.53,282.35Zm14.1,7.22c0-.05.05-3.36.06-4.78a.77.77,0,0,1,.85-.62h.53c.66,0,1.2.41,1.2.9v2.07c0,.68,0,.65-.68,1.14Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "376.215px 287.653px"
    },
    id: "elgu9qft2hms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9x8gn7odn84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383,283.71H381.7c-.07-.15.07-.39.26-.63L382,283a5.15,5.15,0,0,1,.67-.64l0,0s-.11-.54-1.39-.26c-.37.08-.72.17-1,.26l-.14,0h0l-.1,0a610.48,610.48,0,0,0-6.4-.08,5.35,5.35,0,0,0-3.24.08H370c-.32-.09-.68-.18-1.05-.26-1.28-.28-1.39.26-1.39.26l.41.74a2.73,2.73,0,0,1,.35,1.33v4.2c0,2.56,2.8,4.66,6.25,4.66h.91a6.62,6.62,0,0,0,5.66-2.71,2.18,2.18,0,0,0,.79-.34l2.43-1.82a1.29,1.29,0,0,0,.57-1v-2.27C384.9,284.35,384,283.71,383,283.71Zm1.29,3.43c0,.68,0,.65-.68,1.14l-2,1.29c0-.05.05-3.36.06-4.78a.77.77,0,0,1,.85-.62h.53c.67,0,1.2.41,1.2.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "376.245px 287.658px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "90.84 299.68 78.7 418.9 82.58 418.9 102.91 299.68 90.84 299.68",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "90.805px 359.29px"
    },
    id: "el4h383ssqscp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.05 299.68 391.66 418.9 395.55 418.9 382.12 299.68 370.05 299.68",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "382.8px 359.29px"
    },
    id: "elbubf651jpbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.3 419.02 107.18 419.02 129.21 299.68 117.15 299.68 103.3 419.02",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "116.255px 359.35px"
    },
    id: "el5qud0y72nsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.87 299.68 394.81 299.68 418.6 419.02 422.48 419.02 406.87 299.68",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "408.645px 359.35px"
    },
    id: "elmxxy2uizrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.44,297.1a3.8,3.8,0,0,0-3.91-3.69H70.18a3.69,3.69,0,1,0,0,7.37H427.53A3.8,3.8,0,0,0,431.44,297.1Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "248.869px 297.095px"
    },
    id: "el4sxmbcb2o06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsmx46lgl61"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "248.869px 356.212px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "90.84 299.68 78.7 418.9 82.58 418.9 102.91 299.68 90.84 299.68",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "90.805px 359.29px"
    },
    id: "eli0eu3211twi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.05 299.68 391.66 418.9 395.55 418.9 382.12 299.68 370.05 299.68",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "382.8px 359.29px"
    },
    id: "elruhvaddlc3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.3 419.02 107.18 419.02 129.21 299.68 117.15 299.68 103.3 419.02",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "116.255px 359.35px"
    },
    id: "elqayvt4q8mhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.87 299.68 394.81 299.68 418.6 419.02 422.48 419.02 406.87 299.68",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.645px 359.35px"
    },
    id: "el90ahh1jvq8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.44,297.1a3.8,3.8,0,0,0-3.91-3.69H70.18a3.69,3.69,0,1,0,0,7.37H427.53A3.8,3.8,0,0,0,431.44,297.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "248.869px 297.095px"
    },
    id: "elr0sx0qdwkjd",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionAnimate);
export default __webpack_public_path__ + "static/media/discussion-animate.d208e06012597f5cbab070c77aa68485.svg";
export { ForwardRef as ReactComponent };